<template>
  <div>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text class="">
      <strong>Title</strong>
      <v-textarea
        label=""
        color="green"
        v-model="item.title"
        :rows="1"
        :autoGrow="true"
        :hide-details="false"
      />
      <strong>Description</strong>
      <v-textarea
        label=""
        color="green"
        v-model="item.description"
        :rows="3"
        :autoGrow="true"
        :hide-details="false"
      />
      <strong v-if="showAudience">Audiences</strong>
      <v-select
        :items="dropdown"
        label="Select from the list"
        multiple
        v-model.trim="item.audience"
        :rules="audiencesRules"
        item-text="title"
        item-value="item"
        required
        v-if="showAudience"
      ></v-select>

      <v-select
        :items="content.exercise_attributes.step1.options"
        label="Options"
        multiple
        v-model.trim="item.options"
        item-text="title"
        item-value="item"
        required
        v-if="
          content.exercise_attributes.step1.options &&
            content.exercise_attributes.step1.options.length
        "
      ></v-select>

      <strong v-if="attributes">Attributes</strong>
      <v-select
        :items="attributes"
        label="Select from the list"
        multiple
        :menu-props="{ maxHeight: '400' }"
        v-model.trim="item.attributes"
        :rules="attributesRules"
        required
        v-if="attributes"
        item-text="title"
        item-value="item"
      ></v-select>
      <strong v-if="showColors">Color</strong>
      <v-select
        :items="colors"
        label="Select a color"
        :menu-props="{ maxHeight: '400' }"
        v-model.trim="item.color"
        :rules="attributesRules"
        required
        v-if="showColors"
        item-text="title"
        item-value="className"
      ></v-select>

      <v-chip v-if="showColors" :class="item.color">Color</v-chip>

      <unit-sub-items v-model="item.items" name="sub">
        <strong>Supporting points</strong>
        <p class="ma-0">Type below and press <strong>Add</strong></p>
      </unit-sub-items>
      <slot></slot>
    </v-card-text>
  </div>
</template>

<script>
// @ is an alias to /src

import { UnitSubItems } from "@/components/units";
import { mapState } from "vuex";

export default {
  name: "EmbedForm",
  data() {
    return {
      item: this.value,
      audiencesRules: [(v) => !!v || "Audience is required"],
      attributesRules: [(v) => !!v || "Attribute is required"],
    };
  },
  props: {
    value: Object,
    name: String,
    title: String,
    showAudience: {
      type: Boolean,
      default: false,
    },
    showColors: {
      type: Boolean,
      default: false,
    },
    attributes: {
      type: Array,
      default: () => {
        [];
      },
    },
    dropdown: {
      type: Array,
      default: () => {
        [];
      },
    },
    content: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["colors"]),
  },
  components: {
    UnitSubItems,
  },
  watch: {
    value: {
      handler: function(val) {
        this.item = val;
      },
      deep: true,
    },
  },
};
</script>
